import {
  CRAWLER_SOURCES_ARE_LOADING,
  CRAWLER_SOURCES_LOADED_WITH_ERROR,
  CRAWLER_SOURCES_SUCCESS_MESSAGE,
  CRAWLER_SOURCES_ARE_LOADED,
  PREVIEWED_CRAWLER_SOURCE_SUCCESSFULLY,
} from "./actionTypes";
import axios from "axios";
import {
  GET_CRAWLER_SOURCES,
  PREVIEW_CRAWLER_SOURCES,
  ADD_CRAWLER_SOURCES,
  UPDATE_CRAWLER_SROUCES,
  DELETE_CRAWLER_SOURCES,
} from "../constants/urls";

export function crawlerSourcesAreLoadingAction(sourcesAreLoading) {
  return {
    type: CRAWLER_SOURCES_ARE_LOADING,
    sourcesAreLoading,
  };
}

export function crawlerSourcesAreLoadedWithErrorAction(
  sourcesAreLoadedWithErrorMessage
) {
  return {
    type: CRAWLER_SOURCES_LOADED_WITH_ERROR,
    sourcesAreLoadedWithErrorMessage,
  };
}

export function crawlerSourcesSuccessMessageFired(sourcesSuccessMessage) {
  return {
    type: CRAWLER_SOURCES_SUCCESS_MESSAGE,
    sourcesSuccessMessage,
  };
}

export function crawlerSourcesAreLoaded(sources) {
  return {
    type: CRAWLER_SOURCES_ARE_LOADED,
    sources,
  };
}

export function previewedCrawlerSourceSuccessfully(previewedCrawlerSource) {
  return {
    type: PREVIEWED_CRAWLER_SOURCE_SUCCESSFULLY,
    previewedCrawlerSource,
  };
}

export function getCrawlerSources(usertoken, status) {
  return (dispatch) => {
    dispatch(crawlerSourcesAreLoadingAction(true));
    axios({
      url: GET_CRAWLER_SOURCES,
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "aplication/json",
      },
      params: {
        usertoken,
        status,
      },
    })
      .then((response) => {
        dispatch(crawlerSourcesAreLoaded(response.data.RegHub_response));
      })
      .catch((err) => {
        dispatch(
          crawlerSourcesAreLoadedWithErrorAction(
            err.response ? err.response.data : err
          )
        );
      });
  };
}

export function previewCrawlerSources(
  usertoken,
  source_name,
  source_url,
  source_country,
  publisher_type,
  search_criteria,
  maxresultsperpage
) {
  return (dispatch) => {
    axios({
      url: PREVIEW_CRAWLER_SOURCES,
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "aplication/json",
      },
      params: {
        usertoken,
        source_name,
        source_url,
        source_country,
        publisher_type,
        search_criteria,
        maxresultsperpage,
      },
    })
      .then((response) => {
        dispatch(previewedCrawlerSourceSuccessfully(response));
      })
      .catch((err) => {
        dispatch(
          crawlerSourcesAreLoadedWithErrorAction(
            err.response ? err.response.data : err
          )
        );
      });
  };
}

export function addCrawlerSources(
  usertoken,
  source_name,
  source_url,
  source_country,
  format,
  publisher_type,
  search_criteria,
  source_language,
  maxresultsperpage
) {
  return (dispatch) => {
    axios({
      url: ADD_CRAWLER_SOURCES,
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "aplication/json",
      },
      params: {
        usertoken,
        source_name,
        source_url,
        source_country,
        format,
        publisher_type,
        search_criteria,
        source_language,
        maxresultsperpage,
      },
    })
      .then((response) => {
        console.log("sourcesActions add_crawler_sources", response);
        dispatch(
          crawlerSourcesSuccessMessageFired(
            response.data ? response.data : response
          )
        );
        dispatch(getCrawlerSources(usertoken, "active"));
      })
      .catch((err) => {
        dispatch(
          crawlerSourcesAreLoadedWithErrorAction(
            err.response ? err.response.data : err
          )
        );
      });
  };
}

export function updateCrawlerSources(
  usertoken,
  source_name,
  source_url,
  source_country,
  format,
  publisher_type,
  search_criteria,
  source_language,
  maxresultsperpage,
  source_id
) {
  return (dispatch) => {
    axios({
      url: UPDATE_CRAWLER_SROUCES,
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "aplication/json",
      },
      params: {
        usertoken,
        source_name,
        source_url,
        source_country,
        format,
        publisher_type,
        search_criteria,
        source_language,
        maxresultsperpage,
        source_id,
      },
    })
      .then((response) => {
        console.log("sourcesActions update_crawler_sources", response);
        dispatch(
          crawlerSourcesSuccessMessageFired(
            response.data ? response.data : response
          )
        );
        dispatch(getCrawlerSources(usertoken, "active"));
      })
      .catch((err) => {
        dispatch(
          crawlerSourcesAreLoadedWithErrorAction(
            err.response ? err.response.data : err
          )
        );
      });
  };
}

export function deleteCrawlerSource(usertoken, source_id) {
  return (dispatch) => {
    axios({
      url: DELETE_CRAWLER_SOURCES,
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "aplication/json",
      },
      params: {
        usertoken,
        source_id,
      },
    })
      .then((response) => {
        console.log("sourcesActions delete_crawler_sources", response);
        dispatch(
          crawlerSourcesSuccessMessageFired(
            response.data ? response.data : response
          )
        );
        dispatch(getCrawlerSources(usertoken, "active"));
      })
      .catch((err) => {
        dispatch(
          crawlerSourcesAreLoadedWithErrorAction(
            err.response ? err.response.data : err
          )
        );
      });
  };
}
